<ion-header>
  <ion-toolbar mode="ios">
    <ion-title mode="ios">
      <div class="title-img">
        <img class="img-logo" src="assets/imgs/estudaqui_logo.png" />
        <span>estudaqui</span>
      </div>
    </ion-title>
  </ion-toolbar>
</ion-header>